import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import api from '../../api';
import { useAuth } from '../../AuthContext';
import InvoiceScanner from '../../components/InvoiceScanner';
import ApprovalGateway from '../../components/ApprovalGateway';
import InventoryPage from '../../components/InventoryPage';
import VoiceInterface from '../../components/VoiceInterface';
import WeatherWidget from '../../components/WeatherWidget';

function ChefDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({ below_par: 0, invoices_today: 0, pending_orders: 0 });

  useEffect(() => {
    async function load() {
      try {
        const [inv, orders] = await Promise.all([
          api.get('/inventory?below_par=true&is_food=true'),
          api.get('/orders?status=draft'),
        ]);
        setStats({
          below_par: inv.data.length,
          pending_orders: orders.data.length,
        });
      } catch (_) {}
    }
    load();
  }, []);

  return (
    <>
      <div className="page-header">
        <span className="page-title">Chef Dashboard</span>
        <span className="text-sm text-gray">Good day, {user?.name}</span>
      </div>
      <div className="page-body">
        <div className="stat-grid">
          <div className={`stat-card ${stats.below_par > 0 ? 'danger' : 'success'}`}>
            <div className="stat-label">Food Below Par</div>
            <div className="stat-value">{stats.below_par}</div>
            <div className="stat-sub">items need ordering</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Pending Orders</div>
            <div className="stat-value">{stats.pending_orders}</div>
            <div className="stat-sub">awaiting approval</div>
          </div>
        </div>

        <div style={{ marginTop: 16 }}>
          <WeatherWidget />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <button className="card" style={{ border: 'none', cursor: 'pointer', padding: 24, textAlign: 'center' }} onClick={() => navigate('/chef/scan')}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>📷</div>
            <div className="font-semibold">Scan Invoice</div>
            <div className="text-sm text-gray mt-1">Photograph a paper invoice</div>
          </button>
          <button className="card" style={{ border: 'none', cursor: 'pointer', padding: 24, textAlign: 'center' }} onClick={() => navigate('/chef/orders')}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>✅</div>
            <div className="font-semibold">Approve Order</div>
            <div className="text-sm text-gray mt-1">Review & approve draft</div>
          </button>
        </div>

        {stats.below_par > 0 && (
          <div className="alert alert-warning mt-6">
            ⚠️ {stats.below_par} food items are below par level. Consider generating a new order.
          </div>
        )}
      </div>
    </>
  );
}

export default function ChefView() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route index element={<ChefDashboard />} />
      <Route path="scan" element={<><div className="page-header"><span className="page-title">Scan Invoice</span></div><div className="page-body"><InvoiceScanner /></div></>} />
      <Route path="inventory" element={<InventoryPage title="Food Inventory" filterFood={true} />} />
      <Route path="orders" element={<><div className="page-header"><span className="page-title">Approve Order</span></div><div className="page-body"><ApprovalGateway /></div></>} />
      <Route path="voice" element={<><div className="page-header"><span className="page-title">Voice</span></div><div className="page-body"><VoiceInterface restaurantId={user?.restaurant_id} /></div></>} />
    </Routes>
  );
}
